import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as _ from 'lodash';
import { YextService } from '@core/services/yext.service';
import { mapYextResponseToReducer } from '@shared/helpers';
import { FacilityYext } from '@models';
import {
  FacilitiesActionTypes,
  FacilityIdActionTypes,
  IFacilitiesRequest,
  IFacilityByIdRequest,
} from '../actions/facilities.actions.types';

/**
 * Facilities Effects
 */
@Injectable()
export class FacilitiesEffects {
  /**
   * Effect Get Facilities
   *
   * @description
   * This effect is triggered by Load All Facilities action.
   */
  getFacilities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FacilitiesActionTypes.request),
      mergeMap((action: IFacilitiesRequest) =>
        this.yextService.getAllFacilities(action.options).pipe(
          map((data) => ({
            type: FacilitiesActionTypes.requestSuccess,
            facilities: _.keyBy(
              mapYextResponseToReducer(data?.response?.entities),
              'id',
            ),
          })),
          catchError((error) =>
            of({
              type: FacilitiesActionTypes.requestFailure,
              error,
            }),
          ),
        ),
      ),
    ),
  );

  /**
   * Effect Get Facilities by ID
   *
   * @description
   * This effect is triggered by Load Facilities by ID action.
   * It receives an id from facility `id`
   */
  getFacilityById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FacilityIdActionTypes.request),
      mergeMap((action: IFacilityByIdRequest) =>
        this.yextService.getFacilityById(action.id, action.options).pipe(
          map((data) => ({
            type: FacilityIdActionTypes.requestSuccess,
            facility: data?.response
              ? { [data.response?.meta?.id]: new FacilityYext(data.response) }
              : {},
          })),
          catchError((error) =>
            of({
              type: FacilityIdActionTypes.requestFailure,
              error,
            }),
          ),
        ),
      ),
    ),
  );

  constructor(private actions$: Actions, private yextService: YextService) {}
}
